export const docs = {
    actions: (proj?: { sdkKey: string; environmentKey: string } | null) => [
        {
            title: 'Environment',
            description:
                'All lower environments are linked to the Development including staging',
            action: {
                text: proj?.environmentKey,
            },
        },
        {
            title: 'Datafile',
            subtitle: proj?.sdkKey,
            action: {
                text: 'Open',
                url: `https://cdn.optimizely.com/datafiles/${proj?.sdkKey}.json`,
            },
        },
    ],
    links: [
        {
            icons: '⚛︎',
            title: 'Optimizely SDK',
            url: 'https://docs.developers.optimizely.com/feature-experimentation/docs/example-usage-of-the-javascript-sdk',
        },
        {
            icons: '⚒',
            title: 'Feature flags',
            url: 'https://docs.developers.optimizely.com/feature-experimentation/docs/create-feature-flags',
        },
        {
            icons: '✦',
            title: 'A/B experiments',
            url: 'https://docs.developers.optimizely.com/feature-experimentation/docs/run-a-b-tests',
        },
        {
            icons: '❖',
            title: 'Targeted delivery',
            url: 'https://docs.developers.optimizely.com/feature-experimentation/docs/run-flag-deliveries',
        },
    ],
};
